import IntroView from './intro/IntroView'
import QuestionView from './question/QuestionView'
import SummaryView from './summary/SummaryView'

export const Views = {
  Intro: IntroView,
  Question: QuestionView,
  Summary: SummaryView,
}

export { default as ChapterView } from './ChapterView'
export { default as EndtestView } from './EndtestView'
